export default __webpack_public_path__ + "ff70cce5608bffb043b9b1ee555040f0.svg";